import { lazy } from 'react'

export const DashboardRoutes = [
    {
        path: '/dashboard',
        component: lazy(() => import('../views')),
        meta: {
            general: true
        }
    }
]

